import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { i18nState } from 'redux-i18n';

import { auth } from './auth';
import { bikeBuddyScheduler } from './bike-buddy-scheduler';
import { companies } from './companies';
import { forgotPassword } from './forgot_password';
import { resetPassword } from './reset_password';
import { acceptInvitation } from './accept-invitation';
import { confirmEmail } from './confirm_email';
import { profile } from './profile';
import { users } from './users';
import { roles } from './roles';
import { serviceItems } from './service_items';
import { serviceDetails } from './service-details';
import { competencies } from './competencies';
import { languages } from './languages';
import { bicycleTypes } from './bicycle-types';
import { promoCodes } from './promo-codes';
import { common } from './common';
import { serviceSlots } from './service-slots';
import { serviceSlotsUnreachable } from './service-slots-unreachable';
import { services } from './services';
import { subscriptions } from './subscriptions';
import { bicycles } from './bicycles';
import { availableBikeBuddy } from './available-bike-buddy';
import { dashboard } from './dashboard';
import { assets } from './assets';
import { operationalRanges } from './operational-ranges';
import { trialGroups } from './trial-group';
import { exportData } from './export-data';
import { products } from './products';
import { expert } from './expert';
import { events } from './events';
import { statistics } from './statistics';
import { serviceTypes } from './service-types';
import { invoiceRows } from './invoice-rows';
import { eventTypes } from './event-types';
import { eventsCalendarDetails } from './events-calendar-details';
import { eventEmailHistory } from './event-email-history';
import { orders } from './orders';
import { orderItems } from './order-items';
import { userInventory } from './user-inventory';
import { inventory } from './inventory';

const appReducer = combineReducers({
  i18nState,
  form: formReducer,
  auth,
  bikeBuddyScheduler,
  companies,
  forgotPassword,
  resetPassword,
  acceptInvitation,
  confirmEmail,
  profile,
  users,
  roles,
  serviceItems,
  serviceDetails,
  competencies,
  languages,
  bicycleTypes,
  promoCodes,
  common,
  serviceSlots,
  serviceSlotsUnreachable,
  services,
  subscriptions,
  bicycles,
  availableBikeBuddy,
  dashboard,
  assets,
  operationalRanges,
  trialGroups,
  exportData,
  products,
  expert,
  events,
  statistics,
  serviceTypes,
  invoiceRows,
  eventTypes,
  eventsCalendarDetails,
  eventEmailHistory,
  orders,
  orderItems,
  userInventory,
  inventory,
});

export const rootReducer = (state, action) => {
  return appReducer(state, action);
};
